import { PageHero } from "../components/PageShell";
import { ROUTES } from "../lib/routes";

const press = [
  { date: "2025 · NOV 18", pub: "The Hindu", title: "BIET launches AI for healthcare research lab in collaboration with district hospital" },
  { date: "2025 · OCT 02", pub: "Deccan Herald", title: "Davanagere institute named in NIRF top-200 engineering colleges, fourth consecutive year" },
  { date: "2025 · SEP 14", pub: "Indian Express", title: "Two BIET students win national-level Smart India Hackathon for waste segregation prototype" },
  { date: "2025 · JUL 06", pub: "Times of India", title: "BIET endowment crosses ₹46 crore mark; new fellowships announced for women in engineering" },
  { date: "2025 · MAR 22", pub: "VijayaVani", title: "Bapuji's BAJA team finishes 11th nationally; designs in-house composite chassis" },
  { date: "2024 · DEC 05", pub: "Vijaya Karnataka", title: "Davanagere campus reaffirmed with NAAC A+ grade in Cycle 3 review" },
  { date: "2024 · NOV 11", pub: "The Hindu BusinessLine", title: "TCS hires 53 from BIET in single drive; six in TCS Digital, two in Prime" },
  { date: "2024 · AUG 28", pub: "Prajavani", title: "Solar rooftop expansion brings BIET closer to net-zero on grid electricity" },
];

export default function MediaKit() {
  return (
    <>
      <PageHero
        variant="hero-editorial"
        eyebrow="Media kit & press"
        title="Brand guidelines, recent coverage."
        lead="Everything you need to write about BIET. Typography rules, official boilerplate, and an archive of recent media coverage. For interviews, statements or campus visits, contact the Office of Public Relations."
        crumbs={[{ label: "About", to: ROUTES.about }, { label: "Media Kit" }]}
        image={null}
      />
      <section className="section">
        <div className="container">
          <div className="two-col">
            <div className="reveal">
              <div className="kicker">Boilerplate</div>
              <h3>Approved description</h3>
              <p style={{ fontFamily: "var(--font-serif)", fontSize: 17, lineHeight: 1.6, color: "var(--text)", borderLeft: "2px solid var(--gold-400)", paddingLeft: 18, marginTop: 14 }}>
                Bapuji Institute of Engineering &amp; Technology, Davanagere (BIET) is an autonomous engineering institution founded in 1979 by the Bapuji Educational Association. NAAC A+ accredited, NBA Tier-I, affiliated to VTU Belagavi. BIET offers nine undergraduate programs, six postgraduate programs, and PhD across all departments.
              </p>
              <p style={{ marginTop: 16, color: "var(--text-soft)", fontSize: 14 }}>For longer-form descriptions, request the full media factsheet from <a href="mailto:pr@bietdvg.edu" style={{ color: "var(--accent-strong)" }}>pr@bietdvg.edu</a>.</p>
            </div>
            <div className="reveal">
              <div className="kicker">Downloadables</div>
              <div className="disc-list" style={{ marginTop: 14 }}>
                <a className="disc-item" href="#"><div className="disc-icon">ZIP</div><div className="disc-info"><div className="name">Full media kit (logos + guide)</div><div className="meta">ZIP · 14.2 MB</div></div><span className="disc-action">Download →</span></a>
                <a className="disc-item" href="#"><div className="disc-icon">PDF</div><div className="disc-info"><div className="name">Brand guidelines</div><div className="meta">PDF · 28 PAGES · 4.1 MB</div></div><span className="disc-action">Download →</span></a>
                <a className="disc-item" href="#"><div className="disc-icon">PDF</div><div className="disc-info"><div className="name">Annual factsheet 2024-25</div><div className="meta">PDF · 4 PAGES · 0.8 MB</div></div><span className="disc-action">Download →</span></a>
              </div>
            </div>
          </div>

          <h2 style={{ marginTop: 80, fontSize: "clamp(28px, 3vw, 40px)", fontWeight: 600 }}>Recent coverage</h2>
          <div className="press-list">
            {press.map((p, i) => (
              <a key={i} href="#" className="press-row">
                <span className="date">{p.date}</span>
                <span className="pub">{p.pub}</span>
                <span className="title">{p.title}</span>
                <span className="arrow">→</span>
              </a>
            ))}
          </div>

          <div className="contact-grid" style={{ marginTop: 80 }}>
            <div className="contact-block">
              <div className="ctype">Press desk</div>
              <h3>Office of Public Relations</h3>
              <dl className="row"><dt>PRO</dt><dd>Dr. Faculty-19</dd><dt>Phone</dt><dd>+91 8192 233 803</dd><dt>Email</dt><dd><a href="mailto:pr@bietdvg.edu">pr@bietdvg.edu</a></dd></dl>
            </div>
            <div className="contact-block">
              <div className="ctype">Interviews</div>
              <h3>Director's office</h3>
              <dl className="row"><dt>Email</dt><dd><a href="mailto:director.office@bietdvg.edu">director.office@bietdvg.edu</a></dd><dt>SLA</dt><dd>Reply within 48h</dd></dl>
            </div>
            <div className="contact-block">
              <div className="ctype">Campus visit</div>
              <h3>Visit coordinator</h3>
              <dl className="row"><dt>Email</dt><dd><a href="mailto:visit@bietdvg.edu">visit@bietdvg.edu</a></dd><dt>Notice</dt><dd>5 working days</dd></dl>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
